// src/data/menuAdapter.js
import { MENU_DATA, getItemName, getItemDesc } from "./menu_data";

// Конвертиране на MENU_DATA във формат, който очакват компонентите
export const getMenuItemsForCategory = (categoryKey, lang = 'bg') => {
  const items = MENU_DATA[categoryKey] || [];
  
  return items.map((item, index) => ({
    id: `${categoryKey}-${index}`,
    name: getItemName(item, lang),
    desc: getItemDesc(item, lang),
    weight: item.weight,
    priceRaw: item.price,
    price: parseFloat(item.price.split(' ')[0]) || 0,
    image: item.img,
    originalName: item.name,
    originalDesc: item.desc
  }));
};

// Списък с категории за навигацията
export const getSortedCategories = () => {
  const order = {
    'STARTER': 1,
    'SOUP': 2,
    'SALAD': 3,
    'MAIN': 4,
    'PASTA': 5,
    'RISOTTO': 6,
    'PIZZA': 7,
    'SIDES': 8,
    'BREAD': 9,
    'DESSERT': 10
  };
  
  return Object.keys(MENU_DATA)
    .map(key => ({ key, order: order[key] || 999 }))
    .sort((a, b) => a.order - b.order);
};